import createContext from '@ant-design/create-react-context';
var MenuContext = createContext({
  inlineCollapsed: false
});
export default MenuContext;
//# sourceMappingURL=MenuContext.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/menu/MenuContext.js
// module id = 198
// module chunks = 0